import { useTranslation } from 'react-i18next';
import Button from '../Button';

interface Props {
  onClickSkip: () => void;
  onClickShare: () => void;
}

export const NPSSurveyNotNow = ({ onClickSkip, onClickShare }: Props) => {
  const { t } = useTranslation();
  return (
    <div className='mx-auto flex grow items-start gap-x-6'>
      <div className='w-1/2'>
        <h2 className='mb-2 max-w-[529px] text-h4 font-extrabold leading-6'>
          {t('Would you like to skip this feedback for now?')}
        </h2>
      </div>
      <div className='flex w-1/2 justify-end gap-x-6'>
        <Button
          styling='naked-blue'
          className='!font-semibold'
          onClick={onClickShare}
          data-testid='share-feedback-btn'
        >
          {t('Share feedback')}
        </Button>
        <Button
          styling='outline'
          onClick={onClickSkip}
          className='min-w-[135px] !rounded-2xl'
          data-testid='skip-feedback-btn'
        >
          {t('Yes, skip')}
        </Button>
      </div>
    </div>
  );
};
